<div class="icon" [class.alternate]="alternateIcon">
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="bar"></div>
</div>
